export default __webpack_public_path__ + "img/portada-inicio.07de1d3a.jpg";